// extracted by mini-css-extract-plugin
export default {"formChoice":"choicePage_formChoice__Ga-fl","ButtonWrapper":"choicePage_ButtonWrapper__5vMuJ","buttonChoice":"choicePage_buttonChoice__qObaG"};